import { REVIEWSCHEDULER } from "../../../utils/Constants";

export const createRSFS_GRIDFilters = (set, get) => ({
    RSFSFilters: {
        selectedAgency: undefined,
        selectedAgencyName: undefined,
        searchText: '',
        selectedFilterOption: undefined,
        datemodified: {
            start_date: "2010-01-01",
            end_date: "2050-01-01"
        },
        page: 1,
        field: '',
        direction: '',
        userType: REVIEWSCHEDULER,
        hideBadPhoneNumber: 1,
        selectedButton: 'None',
        selectedAgent: [],
        scheduled_by_date: undefined,
        active_call_date_from: undefined,
        active_call_date_to: undefined,
        filter_by_column_name: undefined,
        newTitle: undefined,
        previousTitle: undefined
    },
    setRSFSFilters: (newFilter) =>
        set((state) => ({
            RSFSFilters: {
                ...state.RSFSFilters,
                ...newFilter,
                datemodified: {
                    ...state.RSFSFilters.datemodified,
                    ...newFilter.datemodified,
                }
            },
        })),
    resetRSFSFilters: () =>
        set(() => ({
            RSFSFilters: {
                selectedAgency: undefined,
                selectedAgencyName: undefined,
                searchText: '',
                selectedFilterOption: undefined,
                datemodified: {
                    start_date: "2010-01-01",
                    end_date: "2050-01-01"
                },
                page: 1,
                field: '',
                direction: '',
                userType: REVIEWSCHEDULER,
                hideBadPhoneNumber: 1,
                selectedButton: 'None',
                selectedAgent: [],
                scheduled_by_date: undefined,
                active_call_date_from: undefined,
                active_call_date_to: undefined,
                filter_by_column_name: undefined,
                newTitle: undefined,
                previousTitle: undefined
            },
        })),
});




// WEBPACK FOOTER //
// ./src/store/slices/FS/RSFS-gridSlice.js